import View from '@/components/atomic/atoms/layout/view/styled';
import styled, { CSSObject } from '@emotion/styled';

const Badge = styled(View)(({ theme }) => {
	const style: CSSObject = {
		backgroundColor: theme.colors.secondaryBrandColor,
		position: 'absolute',
		display: 'block',
		margin: 0,
		borderRadius: 15,
		small: {
			fontFamily: theme.font.families.secondary.demiBold,
			fontWeight: 600,
			fontSize: 10,
			lineHeight: '15px',
			color: theme.colors.primaryNavBackground,
			display: 'block',
			paddingLeft: 4.46,
			paddingRight: 4.45,
			position: 'relative',
		},
	};

	return style;
}).withComponent('p');

export default Badge;
